<template>
    <div class="d-flex flex-row w-100 partTags">
        <grid-content class="w-100 partTags">
            <grid-content-row>
                <div class="d-flex align-items-center">
                    <div class="mr-3">
                        <review-icon :icon="review.origin"></review-icon>
                    </div>
                    <div class="w-100 partTags">
                        <h6 class="mb-0 mt-2">
                            <a class="text-dark cursor-pointer"
                                :href="$laroute.route('contacts', { name: encodeURIComponent(review.reviewer_name) })">
                                <strong>
                                    {{ review.reviewer_name }}
                                </strong>
                            </a>
                            <div class="float-right text-right">
                                <rating-stars
                                    v-if="showRating"
                                    :stars="5"
                                    :disabled="true"
                                    :value="review.rating"
                                    style="font-size: 1rem;">
                                </rating-stars>
                                <p
                                    v-else
                                    class="recommendation"
                                    :class="recommendation_type"
                                > {{ review.recommendation_type }} </p>
                                <nps-rating class="ml-auto" v-if="type === 'nps'" :rating="review.rating"></nps-rating>
                                <p class="mb-0 review-date">{{ review.review_date | fromNow }}</p>
                            </div>
                        </h6>
                        <div class="dropdown" style="margin-left: -5px;">
                            <div class="dropdown-toggle btn btn-default btn-icon btn-sm" data-toggle="dropdown">
                                <small class="text-muted">
                                    {{ review.location.name }}
                                </small>
                            </div>
                            <div class="dropdown-menu location-details" style="min-width: 250px;">
                                <div class="d-flex px-2 mt-1 mb-2" v-if="review.campaign">
                                    <div class="text-right text-muted" style="width: 70px;">
                                        Campaign:
                                    </div>
                                    <b class="ml-2">
                                        {{ review.campaign.name }}
                                    </b>
                                </div>
                                <div class="d-flex px-2 mt-1 mb-2">
                                    <div class="text-right text-muted" style="width: 70px;">
                                        Origin:
                                    </div>
                                    <b class="ml-2 text-capitalize">
                                        {{ review.origin }}
                                    </b>
                                </div>
                                <div class="d-flex px-2 mt-1 mb-2">
                                    <div class="text-right text-muted" style="width: 70px;">
                                        Date:
                                    </div>
                                    <b class="ml-2">
                                        {{ review.review_date | date }}
                                    </b>
                                </div>
                                <div class="d-flex px-2 mt-1 mb-2" v-if="review.sent_by">
                                    <div class="text-right text-muted" style="width: 70px;">
                                        Sent by:
                                    </div>
                                    <b class="ml-2">
                                        {{ review.sent_by.name }}
                                    </b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-2" v-if="review.title">
                    <h6 class="font-weight-bold">
                        {{ review.title }}
                    </h6>
                </div>

                <div class="mt-2 d-flex justify-content-between align-items-center">
                    <div v-if="review.body" v-html="review.body"></div>
                    <div v-else class="font-italic text-black-50">
                        (no feedback)
                    </div>
                    <div class="d-flex">
                        <button type="button" class="btn btn-outline-primary ml-2"
                            v-if="review.origin === 'google'
                                && review.location.facebook_page
                                && review.rating === 5"
                            @click="publish">
                            <i class="fab fa-facebook"></i>
                        </button>
                        <button type="button" class="btn btn-light text-muted ml-2 d-flex align-items-center"
                            v-if="google_review_reply"
                            @click="openModal">
                            <i class="fas fa-reply"></i>
                            <span class="ml-1">Reply</span>
                        </button>
                    </div>
                </div>

                <div class="mt-2 d-flex justify-content-between align-items-center"
                    v-if="review.origin === 'google' && review.review_reply">
                    <div class="ml-3 review__reply">
                        {{ review.review_reply }}
                    </div>
                    <div class="d-flex align-items-center" v-if="google_review_reply_edit">
                        <button type="button" class="btn btn-light text-muted ml-2 d-flex align-items-center"
                            @click="openModal">
                            <i class="fas fa-pen"></i>
                            <span class="ml-1">Edit</span>
                        </button>
                        <button type="button" class="btn btn-outline-danger ml-2 border-0" @click="deleteReply(review.id)">
                            Delete
                        </button>
                    </div>
                </div>
            </grid-content-row>
            <grid-content-row v-if="review.comments.length">
                <b>Comments:</b>
                <div class="px-3 py-1 mt-2" v-for="comment of review.comments" :key="comment.id">
                    <span>
                        <b class="mr-1">
                            {{ comment.user.name }}
                        </b>
                        <span class="text-muted mr-2">
                            (replied {{ comment.created_at | fromNow }}):
                        </span>
                    </span>
                    <div>{{ comment.body }}</div>
                </div>
            </grid-content-row>
        </grid-content>
        <grid-content style="max-width: 33%;">
            <grid-content-row>
                <div class="mb-2 text-right">
                    <div class="dropdown">
                        <div class="dropdown-toggle btn btn-default btn-icon btn-sm" data-toggle="dropdown"
                            v-if="swell_review">
                            <i class="fa fa-ellipsis-h"></i>
                        </div>
                        <div class="dropdown-menu dropdown-menu-right">
                            <a class="dropdown-item"
                                v-if="review.url"
                                v-tooltip="reply_tooltip"
                                :href="review.url"
                                target="_blank">
                                Reply
                            </a>
                            <a class="dropdown-item" href="#"
                                v-if="swell_review"
                                @click.prevent.stop="replySwell">
                                Reply
                            </a>
                            <a class="dropdown-item" href="#"
                                v-if="swell_review"
                                @click.prevent.stop="resend">
                                {{ resending ? 'Resending...' : 'Resend' }}
                                <i class="fa fa-spinner fa-spin ml-1" v-if="resending"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <tags ref="divTag" class="w-100 partTags" v-model="review.tags" :options="tags" @input="updateTags"></tags>
            </grid-content-row>
        </grid-content>
        
        <reply-review-modal
            ref="replyModal"
            :review="review"
            @replied="$emit('updated')"
        />
        
        <reply-review-google-modal
            ref="replyGoogleModal"
            :review="review"
            @replied="$emit('updated')"
        />
    </div>
</template>

<script>
    export default {
        props: {
            review: { required: true },
            type: { default: 'public' },
            tags: { default: () => [] },
        },

        data() {
            return {
                resending: false,
                reply_tooltip: {
                    title: 'You will be redirected to review site to write your response.',
                    placement: 'left',
                }
            };
        },

        computed: {
            recommendedClass() {
                return this.review.recommended ? 'fa-thumbs-up text-success' : 'fa-thumbs-down text-danger';
            },

            showRating() {
                if (this.review.recommendation_type && this.review.origin === 'facebook' && this.review.rating === 0) {
                    return false;
                }

                return this.type === 'cx' || (this.type === 'public' && this.review.rating !== null);
            },

            swell_review() {
                return this.review.origin === 'swell';
            },

            google_review_reply() {
                return this.review.origin === 'google'
                    && !!this.review.location.google_my_business_account_id
                    && !this.review.review_reply;
            },

            google_review_reply_edit() {
                return !!this.review.review_reply;
            },

            recommendation_type() {
                if (this.review.recommendation_type === 'negative') {
                    return 'recommendation-negative';
                }

                return 'recommendation-positive';
            }
        },

        methods: {
            async updateTags(review) {
                try {
                    this.updating_tags = true;
                    const form = new Form({
                        tag_ids: this.review.tags.map(t => t.id),
                    });
                    const { data } = await form.put(this.$laroute.route('api.reviews.update-tags', { review: this.review.id }))
                } catch (response) {
                    this.$alert({ message: response.data.message || 'Something went wrong...', type: 'error', title: 'Oops!' });
                }
            },

            replySwell() {
                this.$refs.replyModal.open();
            },

            async resend() {
                this.resending = true;
                try {
                    await this.$http.post(this.$laroute.route('api.invites.resend', { invite: this.review.invite_id }));
                    this.$alert({
                        title: 'Invite resent',
                        type: 'success',
                    })
                } catch (error) {
                    this.$alert({
                        type: 'error',
                        title: 'Oops',
                        message: 'Sorry! We could not resend the invite to the contact.'
                    });
                } finally {
                    this.resending = false;
                }
            },

            openModal() {
                this.$refs.replyGoogleModal.open();
            },

            deleteReply(review) {
                const url = this.$laroute.route('google-reviews-reply-delete', {review: review});
                this.$confirm().then(() => {
                    this.$http.delete(url).then(() => {
                        this.$emit('updated');
                        this.$alert({
                            type: 'success',
                            title: 'Success!',
                            message: 'Reply deleted'
                        });
                    })
                    .catch(() => {
                        this.$alert({
                            type: 'error',
                            title: 'Oops! Error deleting reply',
                            message: 'Please try again or contact your system admin.'
                        });
                    });
                })
                .catch(
                    err => console.log('err from delete', err)
                )
            },

            publish() {
                this.$confirm({
                    title: 'Post on Facebook?',
                    text: `This will be posted on: ${this.review.location.facebook_page_name}`,
                    confirmButtonColor: '#28a745',
                    confirmButtonText: 'Yes'
                })
                .then(() => {
                    this.$http.post(this.$laroute.route('publish-review', {
                        location: this.review.location.id,
                        review: this.review.id
                    }))
                    .then(() => {
                        this.$alert({
                            type: 'success',
                            title: 'Success!',
                            message: 'Publish successful'
                        });
                    })
                    .catch(() => {
                        this.$alert({
                            type: 'error',
                            title: 'Oops! Error publish',
                            message: 'Please try again or contact your system admin.'
                        });
                    });
                })
                
            }
        }
    }
</script>

<style lang="scss" scoped>
    .location-details {
        font-size: .8rem;
    }

    .review-date {
        font-size: .8rem;
        color: #777;
        margin-top: 0.5rem;
    }

    .review__reply {
        border-left: 3px solid #e5e5e5;
        padding: 5px 0 0 10px;
    }

    .partTags{
        height: 100% !important;
    }

    .recommendation {
        text-transform: capitalize;
        font-weight: 900;
    }

    .recommendation-positive {
        color: green;
    }

    .recommendation-negative {
        color: red;
    }
</style>
